import IFellowshipPost from "../interfaces/IFellowshipPost";
import IApiResponse from "../interfaces/IApiResponse";
import { isPlatform } from "@ionic/react";
import FellowshipPostServiceWeb from "./web/FellowshipPostServiceWeb";
import FellowshipPostServiceHybrid from "./hybrid/FellowshipPostServiceHybrid";

export interface IFellowshipPostService {
    createFellowshipPost: (fellowshipPost: IFellowshipPost) => Promise<IApiResponse<IFellowshipPost>>,
    getFellowshipPost: (fellowshipPostId: string) =>  Promise<IApiResponse<IFellowshipPost>>,
    getAllFellowshipPosts: () => Promise<IApiResponse<IFellowshipPost[]>>,
    getAllGroupFellowshipPosts: (groupId: string) => Promise<IApiResponse<IFellowshipPost[]>>,
    getLastSortDate: (groupId: string) => Promise<IApiResponse<Date>>,
    getLastModifiedDate: (groupId: string) => Promise<IApiResponse<Date>>,
    getOlderPosts: (groupId: string, lastSortDate: Date, limit: number) => Promise<IApiResponse<IFellowshipPost[]>>,
    updateFellowshipPost: (fellowshipPost: IFellowshipPost, isSyncUpdate?: boolean) => Promise<IApiResponse<IFellowshipPost>>,
    updateFellowshipPosts: (fellowshipPosts: IFellowshipPost[]) => Promise<IApiResponse<boolean>>,
    deleteFellowshipPost: (fellowshipPost: IFellowshipPost) => Promise<IApiResponse<boolean>>,
}

const FellowshipPostService: IFellowshipPostService = {
    createFellowshipPost: (fellowshipPost) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.createFellowshipPost(fellowshipPost);
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.createFellowshipPost(fellowshipPost);
        }  
    },

    getFellowshipPost: (fellowshipPostId) =>  {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.getFellowshipPost(fellowshipPostId);
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.getFellowshipPost(fellowshipPostId);
        }  
    },

    getAllFellowshipPosts: () => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.getAllFellowshipPosts();
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.getAllFellowshipPosts();
        } 
    },

    getAllGroupFellowshipPosts: (groupId: string) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.getAllFellowshipPosts();
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.getAllFellowshipPosts();
        } 
    },

    getLastSortDate: (groupId: string) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.getLastSortDate(groupId);
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.getLastSortDate(groupId);
        } 
    },

    getLastModifiedDate: (groupId: string) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.getLastModifiedDate(groupId);
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.getLastModifiedDate(groupId);
        } 
    },

    getOlderPosts: (groupId: string, lastSortDate: Date, limit: number) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.getOlderPosts(groupId, lastSortDate, limit);
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.getOlderPosts(groupId, lastSortDate, limit);
        } 
    },

    updateFellowshipPost: (fellowshipPost, isSyncUpdate?) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService - update')
            return FellowshipPostServiceHybrid.updateFellowshipPost(fellowshipPost, isSyncUpdate);
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.updateFellowshipPost(fellowshipPost, isSyncUpdate);
        } 
    },

    updateFellowshipPosts: (fellowshipPosts) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.updateFellowshipPosts(fellowshipPosts);
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.updateFellowshipPosts(fellowshipPosts);
        } 
    },

    deleteFellowshipPost: (fellowshipPost) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - FellowshipPostService')
            return FellowshipPostServiceHybrid.deleteFellowshipPost(fellowshipPost);
        } else {
            console.log('WEB - FellowshipPostService')
            return FellowshipPostServiceWeb.deleteFellowshipPost(fellowshipPost);
        } 
    },
}

export default FellowshipPostService;